import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import asModal from '../../../../../components/as-modal';

import Global from '../../../../../store/global-selectors';
import messages from '../messages';
import style from '../style.module.less';

const deallocateMessage = <FormattedMessage {...messages.deallocateModalDeallocate} />;

const ConfirmActionModal = ({ onConfirm, selectedProductId, onClose }) => {
  const [selectedProduct] = useSelector((state) =>
    Global.selectEntitiesInventoryByProductIds(state, {
      productIds: [selectedProductId],
    }),
  );

  return (
    <Modal className={style['confirmation-modal']} size='small'>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage {...messages.deallocateModalTitle} values={{ sku: selectedProduct.sku }} />
      </ModalHeader>
      <ModalBody className={style['confirmation-modal-body']}>
        {selectedProduct.allocated !== 0 && deallocateMessage}
        {selectedProduct.allocated === 0 && (
          <FormattedMessage {...messages.deallocateModalDeallocateZero} values={{ name: selectedProduct.productName }} />
        )}
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose} theme='tertiary'>
          <FormattedMessage {...messages.cancel} />
        </Button>
        <Button onClick={onConfirm} theme='primary'>
          <div className={style['combine-button']}>
            <FormattedMessage {...messages.confirm} />
          </div>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ConfirmActionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  selectedProductId: PropTypes.string.isRequired,
};

export default asModal(ConfirmActionModal);
